import AdminReport from './AdminReport';
export default AdminReport;
